import { useEffect, useContext, useState } from 'react';
import { useParams } from "react-router-dom";
import
{
  SubscriptionContainer,
} from './Products.styles';
import { routes } from '../../../options/routes';
import MainWrapper from '../../../components/Wrappers/MainWrapper/MainWrapper';
import Title from '../../../components/Typography/Title/Title';
import SectionContainer from '../../../components/Containers/SectionContainer/SectionContainer';
import SubscriptionsList from '../../../components/Tables/SubscriptionsList/SubscriptionsList';
import RezzilPlayerSubscriptionModal from '../../../components/RezzilPlayerSubscribe/SubscriptionModal/SubscriptionModal';
import StandardModal from '../../../components/Modals/StandardModal/StandardModal';
// Contexts
import { BaseContext } from '../../../providers/Global/BaseProvider';
import { ProductsContext } from '../../../providers/Admin/ProductsProvider';
import SubscriptionChangeForm from '../../../components/Forms/SubscriptionChangeForm/SubscriptionChangeForm';
import { useCallback } from 'react';

//API
import { downgradeSubscription, getSubscriptions, subscriptionRenew, upgradeSubscription } from '../../../api';
import { getClubId } from '../../../utils/helpers/clubHelper';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Typography } from '@mui/material';
import { FirstPlayerContainer } from '../Stats/ClubStats/ClubStats.styles';
import CustomTableWrapper from '../../../components/Tables/CustomTableWrapper/CustomTableWrapper';
import { StyledTable, StyledTableBody, StyledTableCell, StyledTableRow } from '../../../components/Tables/SubscriptionsList/SubscriptionsList.styles';
import CustomTableHead from '../../../components/Tables/CustomTableHead/CustomTableHead';
import { formatStandardDateString } from '../../../utils/helpers/formatDateString';
import { hasCorrectRole } from '../../../utils/helpers/licenceHelper';


const Products = () =>
{
  const baseContext = useContext(BaseContext);
  const { checkoutRedirect } = useParams();
  const [refetchedLicences, setRefetchedLicences] = useState(false);
  const productsContext = useContext(ProductsContext);
  const [indexProductsList, setIndexProductsList] = useState([]);
  const [rezzilPlayerProductsList, setRezzilPlayerProductsList] = useState([]);
  const [stripeProducts, setStripeProducts] = useState();
  const [subscriptionChangeOpen, setSubscriptionChangeOpen] = useState(false);
  const [currentSubscription, setCurrentSubscription] = useState();
  const [dataLoading, setDataLoading] = useState(true);
  const [autoRenewLoading, setAutoRenewLoading] = useState(false);
  const [licencesModalOpen, setLicencesModalOpen] = useState(false);
  const [error, setError] = useState({
    show: false,
    message: '',
  });
  const [subscriptionData, setSubscriptionData] = useState(null);

  const refetchBaseData = useCallback(() =>
  {
    baseContext.getBaseData();
  }, [baseContext])

  useEffect(() =>
  {
    if (checkoutRedirect && !refetchedLicences)
    {
      setRefetchedLicences(true);
      setTimeout(() =>
      {
        refetchBaseData();
      }, [5000]);
    }
  }, [checkoutRedirect, refetchBaseData, refetchedLicences]);

  useEffect(() =>
  {
    if (!baseContext.baseData.loading && !productsContext.productsData.loading)
    {
      setDataLoading(false);

      setIndexProductsList(productsContext.productsData.indexSubscriptions);
      console.log('list', productsContext.productsData.indexSubscriptions);
      setRezzilPlayerProductsList(productsContext.productsData.rezzilPlayerSubscriptions);
      setStripeProducts(productsContext.productsData.products);
    }

  }, [baseContext, productsContext]);

  useEffect(async () =>
  {
    if (!subscriptionData)
    {
      const clubId = await getClubId();
      const subscriptionResponse = await getSubscriptions(clubId);

      if (subscriptionResponse.success)
      {
        let subArray = [];
        for (const [userId, subRow] of Object.entries(subscriptionResponse.data))
        {

          if (subRow.data.length)
          {
            subArray.push({ userId, data: subRow.data })
            console.log(`stuff ${userId}`, subRow)
          }
        }
        console.log('sub', clubId, subArray);
        setSubscriptionData(subArray)
      }
    }
  });
  const handleBannerClose = () =>
  {
    setError({
      show: false,
      message: '',
    });
  };

  const handleAddLicenceClick = () =>
  {
    window.location.href = routes.indexLicences;
  }

  const handleSubscriptionChangeClick = (currentSubscriptionId) =>
  {
    const subscription = indexProductsList.concat(rezzilPlayerProductsList).find((subscription) => subscription.id === currentSubscriptionId);
    setCurrentSubscription(subscription);
    setSubscriptionChangeOpen(true);
  };

  const handleAutoRenewChange = async (id) =>
  {
    // Update autoRenew data - convert checked bool to int (either 0 or 1)
    const subscriptionUpdate = indexProductsList.concat(rezzilPlayerProductsList).find((subscription) => subscription.id === id);

    // Trigger API call
    if (!subscriptionUpdate)
    {
      return;
    }
    setAutoRenewLoading(id);
    await subscriptionRenew({
      subscriptionId: id,
      renew: subscriptionUpdate.autoRenew === 0,
    });
    await productsContext.getProductsData(baseContext.baseData.clubProfile.id);
    setAutoRenewLoading(false);
  };

  const handleAddRezzilPlayerLicenceClick = () => setLicencesModalOpen(true);

  const handleLicencesModalClose = () => setLicencesModalOpen(false);
  const handleChangeSubscription = async () =>
  {
    const isDowngrade = currentSubscription.frequency === 'Annual';
    if (isDowngrade)
    {
      await downgradeSubscription({
        subscriptionId: currentSubscription.id,
        newPriceId: currentSubscription.changeTo?.id
      })
      setError({
        show: false,
        message: 'Subscription successfully downgraded',
      });
    } else
    {
      await upgradeSubscription({
        subscriptionId: currentSubscription.id,
        newPriceId: currentSubscription.changeTo?.id
      });
      setError({
        show: false,
        message: 'Subscription successfully upgraded',
      });
    }

    setSubscriptionChangeOpen(false);
    setCurrentSubscription(undefined);
  };

  return (
    <>
      {
        <MainWrapper
          error={error.show}
          apiMessage={error.message}
          handleBannerClose={handleBannerClose}
          activeRoute={routes.adminProducts}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={dataLoading}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
          licences={baseContext.baseData.licences}
        >
          <Title
            text={'Your Products'}
          />
          <SubscriptionContainer>
            <SectionContainer
              sectionTitle={'Rezzil Index'}
              titleBtnText={indexProductsList.length ? 'Add licence' : ''}
              onTitleBtnClick={handleAddLicenceClick}
            >
              <SubscriptionsList
                subscriptions={indexProductsList}
                onAutoRenewChange={handleAutoRenewChange}
                autoRenewLoading={autoRenewLoading}
                onSubscriptionChangeClick={handleSubscriptionChangeClick}
              />
            </SectionContainer>
          </SubscriptionContainer>
          {hasCorrectRole(['REZZIL_SUPER_ADMIN']) && subscriptionData?.length > 0 &&
            <SubscriptionContainer>
              <SectionContainer sectionTitle={'Stripe Subscription Information'}>
                <CustomTableWrapper>
                  <StyledTable>
                    <CustomTableHead
                      columnHeadings={[
                        {
                          id: "col0",
                          label: "License Type"
                        },
                        {
                          id: "col1",
                          label: "Object Type",
                          align: 'center'
                        },
                        {
                          id: "col2",
                          label: "Period Start",
                          align: 'center'
                        },
                        {
                          id: "col3",
                          label: "Period End",
                          align: 'center'
                        },
                        {
                          id: "col4",
                          label: "Status",
                          align: 'center'
                        },
                        {
                          id: "col5",
                          label: "Raw data",
                        },

                      ]}
                    />
                    <StyledTableBody>
                      {subscriptionData.length && subscriptionData[0].data.length && subscriptionData[0].data.map((licence) =>
                      {
                        return (
                          <>
                            <StyledTableRow
                              key="0"
                            >
                              <StyledTableCell
                                align="left">
                                {licence.items.data[0].plan.metadata.license_type}
                              </StyledTableCell>
                              <StyledTableCell
                                align="center">
                                {licence.object}
                              </StyledTableCell>
                              <StyledTableCell
                                align="center">
                                {formatStandardDateString(licence.current_period_start)}
                              </StyledTableCell>
                              <StyledTableCell
                                align="center">
                                {formatStandardDateString(licence.current_period_end)}
                              </StyledTableCell>
                              <StyledTableCell
                                align="center">
                                {licence.status}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left">
                                <Box
                                  sx={{
                                    overflow: 'auto',
                                    fontSize: '0.7em',
                                    maxHeight: 300,
                                  }}
                                >
                                  <pre>{JSON.stringify(licence, null, 2)}</pre>
                                </Box>
                              </StyledTableCell>
                            </StyledTableRow>
                          </>
                        );
                      })}
                    </StyledTableBody>
                  </StyledTable>
                </CustomTableWrapper >
              </SectionContainer >
            </SubscriptionContainer >
          }
          {
            licencesModalOpen &&
            <StandardModal
              open={licencesModalOpen}
              onClose={handleLicencesModalClose}
              title={`Add Licences`}
              hideCancelBtn
              btnText={'Cancel'}
              width={600}
            >
              <RezzilPlayerSubscriptionModal stripeProducts={stripeProducts} />
            </StandardModal>
          }
          {
            subscriptionChangeOpen &&
            <StandardModal
              width={600}
              open={subscriptionChangeOpen}
              onClose={setSubscriptionChangeOpen}
              title={currentSubscription.frequency === 'Monthly' ? 'Upgrade Subscription' : 'Downgrade Subscription'}
              btnText={currentSubscription.frequency === 'Monthly' ? 'Next' : 'Downgrade Subscription'}
              onClick={handleChangeSubscription}
            >
              <SubscriptionChangeForm subscription={currentSubscription} isDowngrade={currentSubscription.frequency !== 'Monthly'} />
            </StandardModal>
          }

        </MainWrapper >
      }
    </>
  );
};

export default Products;
